<div class="modal-body">
  <div id="divPlaceOfferParent">
    <place-offer [inputOfferGuid]="leadGUID" [propType]="propType" [IsFromPropertyView]="true"  [fromOfferMatrix]="fromOfferMatrix" [isFromQuickEdit]="true" [LivePropertyGuid]="LivePropertyGuid" (close) ="closeModal()"></place-offer>
  </div>
</div>
